import {
  SVButton,
  SVListFilters,
  SVListPagination,
  SVLoader,
} from '@/components/core';
import CustomersList from '@/components/customers/CustomersList';
import DefaultLayout from '@/components/layouts/DefaultLayout';
import { ROUTES } from '@/constants/routes';
import { useGetCustomerList } from '@/hooks/requests/useCustomers';
import useBuildListFilters from '@/hooks/requests/useBuildListFilters';
import { formatCurrency } from '@/utils/currency';
import { Box, Card, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { FILTERS } from '@/constants/filters';

export default function CustomersListPage() {
  const navigate = useNavigate();
  const {
    customers,
    aggregateInfo,
    isCustomersPending,
    totalRecordCount,
    isSuccess,
  } = useGetCustomerList();
  const { defaultValues, filters } = useBuildListFilters({
    enabled: isSuccess,
    extraFilters: [FILTERS.STATUS, FILTERS.BANK_ACCOUNT_STATUS],
    hasCompanyFilter: true,
    hasTeammateFilter: true,
    hasBusinessFilter: true,
  });

  return (
    <DefaultLayout
      header={`Customers ${totalRecordCount ? `(${totalRecordCount})` : ''}`}
      buttons={[
        <SVButton
          onClick={() => navigate(ROUTES.CUSTOMERS_ADD)}
          fullWidth
          key="add"
          aria-label="Add Customer">
          Add
        </SVButton>,
      ]}>
      {aggregateInfo && (
        <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2, mb: 2 }}>
          <Typography>
            Total Bank Accounts:{' '}
            <Typography component="span" fontWeight="bold">
              {aggregateInfo.totalBankAccounts}
            </Typography>
          </Typography>
          <Typography>
            Total Available Balance Across Accounts:{' '}
            <Typography component="span" fontWeight="bold">
              {formatCurrency({
                amount: aggregateInfo.totalAvailableBalance.value,
              })}
            </Typography>
          </Typography>
        </Box>
      )}
      <SVListFilters
        defaultValues={defaultValues}
        filters={filters}
        searchLabel="Search by Email Address"
      />
      {isCustomersPending ? (
        <SVLoader />
      ) : (
        <>
          {customers.length === 0 ? (
            <Card>
              <Typography>No results found</Typography>
            </Card>
          ) : (
            <Stack spacing={2}>
              <CustomersList customers={customers} />
              <SVListPagination totalRecordCount={totalRecordCount} />
            </Stack>
          )}
        </>
      )}
    </DefaultLayout>
  );
}
